import { Component, OnInit, OnDestroy } from '@angular/core';
import { AdminService } from '../../../services/admin.service'

@Component({
  selector: 'app-manageraces',
  templateUrl: './manageraces.component.html',
  styleUrls: ['./manageraces.component.scss']
})
export class ManageRacesComponent implements OnInit {

  constructor(private adminService: AdminService) { }

  ngOnInit() {

  }

  updateRaceResults() {
    this.adminService.updateCurrentNascarResult();
  }

}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/nascar/manageraces/manageraces.component.ts